export const SET_CONTENT = 'content/SET_CONTENT';
export const SET_CONTENTS = 'content/SET_CONTENTS';
